// Dashboard checkout state handling
function checkoutState(event) {
  var target = event.target
  var recordId = target.getAttribute("record")
  var value = target.value

  const token = document.querySelector('meta[name="csrf-token"]').content

  fetch('/dashboard/checkout/state?id='+recordId+'&value='+value, {
    method: 'POST',
    headers: {
      "X-CSRF-Token": token,
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return response.json()
  }).then(function (response) {
    //console.log("set state response", response)
  })["catch"](function (error) {
    console.error('Error:', error)
  })
}

function bookShipping(event) {
  console.log("book button clicked", event)

  var bookShippingButton = event.target
  var recordId = bookShippingButton.getAttribute("record")
  console.log("recordId", recordId)

  const token = document.querySelector('meta[name="csrf-token"]').content

  fetch('/dashboard/checkout/order-shipping?id='+recordId, {
    method: 'POST',
    headers: {
      "X-CSRF-Token": token,
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return response.json()
  }).then(function (response) {
    console.log("order shipping response", response)

    setTimeout(function () {
      window.location.reload()
    }, 410)
  })["catch"](function (error) {
    console.error('Error:', error)
  })
}

document.addEventListener("turbolinks:load", function () {
  var radioSelects = document.getElementsByClassName("checkout-state-radio")

  for (var i=0; i<radioSelects.length; i++) {
    radioSelects[i].addEventListener("click", checkoutState)
  }

  var bookShippingButtons = document.getElementsByClassName("bookShippingButton")
  if (bookShippingButtons === null) { return }

  for (var i=0; i<bookShippingButtons.length; i++) {
    bookShippingButtons[i].addEventListener("click", bookShipping)
  }
})
